import type { UseSearchTopFoundProductsProps } from '@maestro/commerce-blocks/components/search-bar/search.types'

import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import { theme } from '@maestro/local/theme'

export const useSearchTopFoundProducts = ({
  productsCount,
  searchResult,
}: UseSearchTopFoundProductsProps) => {
  const t = useTranslations('commerce-blocks')
  const carouselSize = theme().search.foundProductsCarouselSize

  const firstTop5Products = useMemo(() => {
    return searchResult?.hits?.slice(0, carouselSize)
  }, [carouselSize, searchResult])
  const showAll = t('search.show-all-products', { count: productsCount })

  return {
    firstTop5Products,
    productsCount,
    showAll,
  }
}
